module.exports = __webpack_public_path__ + "618eb2d099801a5938d07dcb1ac77093.jpg";